module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="group-item">\n    <a class="button button-secondary pull-right add-button">\n        ';
 if(mode == "add" ) { 
__p+='\n        Add names\n        ';
 } else if(mode == "add-group"){ 
__p+='\n        Add group\n        ';
 } else if(mode == "remove-group"){ 
__p+='\n        Remove group\n        ';
 } 
__p+='\n    </a>\n    <strong>\n        ';
 if(group_type == "school_class"){ 
__p+=' \n            Class\n        ';
 } else if(group_type == "school_year"){ 
__p+='\n            Year\n        ';
 } else if(group_type == "school_name"){ 
__p+='\n            School\n        ';
 } else if(group_type == "other"){ 
__p+='\n            User Defined\n        ';
 } else{ 
__p+='\n            ?\n        ';
 } 
__p+='\n    </strong>\n    '+
((__t=( name ))==null?'':_.escape(__t))+
'\n    <div style="clear:both"></div>\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./base/templates/contacts/group.html
// module id = 262
// module chunks = 0